import {comMapping} from '../../util/Function/comMapping.js'
export default{
	pagination:{
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey:0
	},
	formlist: [{
		prop: "type",
		label: "类型",
		type: "select",
		width:"220px",
		selectval:[
			{
				label:"报表 ",
				value:"1"
			},
			{
				label:"完税凭证",
				value:"2"
			},
			{
				label:"涉税资料",
				value:"3"
			},
			{
				label: "强制弹框附注",
				value: "4"
			}
		]
	
	},{
		prop: "name",
		label: "名称",
		type: "input",
		width:"220px"
	
	},{
		prop: "description",
		label: "描述",
		type: "textarea",
		width:"380px"
	
	}], 
	searchlistzc: [
		{
			prop: "policyTitle",
			label: '标题',
			type: "input"
		},
		{
			prop: "policyType",
			label: '政策类型',
			type: "select",
			selectval: comMapping.$sszskzclx,
		},
		{
			prop: "isValid",
			label: '是否失效',
			type: "select",
			selectval: [
				{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				}
			],
		},
	],
	formdatazc: {
		policyTitle: "",
		isValid: "1",
		policyType: "1",
		fbDanw: "",
		policyNum: "",
		xianggxz: "",
		fabTime: "",
	},
	seezcformlist: [
		{
			prop: "policyTitle",
			label: "标题",
			type: "input",
			istosee: true
		},
		{
			prop: "policyNum",
			label: "发文字号",
			type: "input",
			istosee: true
		},
		{
			prop: "isValid",
			label: "是否失效",
			type: "radio",
			radioval: [
				{
					label: "是",
					value: "1"
				},
				{
					label: "否",
					value: "2"
				}
			],
			istosee: true
		},
		{
			prop: "xianggxz",
			label: "相关税种",
			type: "input",
			istosee: true
		},
		{
			prop: "policyType",
			label: "政策类型",
			type: "radio",
			istosee: true,
			radioval: comMapping.$sszskzclx,
		},
		{
			prop: "fabTime",
			label: "发文日期",
			type: "input",
			istosee: true
		},
	
		{
			prop: "implementTime",
			label: "施行日期",
			type: "input",
			istosee: true
		},
		{
			prop: "fbdanw",
			label: "发文机构",
			type: "input",
			istosee: true
		},
	],
	headDatazc: [
		{
			title: "标题",
			prop: "policyTitle",
			width: "200",
		},
		{
			title: "发文字号",
			prop: "policyNum",
			width: "200",
		},
		{
			title: "相关文档",
			prop: "policyFile",
			width: "200"
		},
		{
			title: "是否失效",
			prop: "isValid",
			width: "200",
			custom: true
		},
		{
			title: "政策类型",
			prop: "policyType",
			width: "150",
			custom: true
	
		},
		{
			title: "相关税种",
			prop: "xianggxz",
			width: "150"
		},
		{
			title: "发文日期",
			prop: "fabTime",
			width: "200"
		},
		{
			title: "施行日期",
			prop: "implementTime", width: "200"
		},
		{
			title: "发文机构",
			prop: "fbdanw",
			width: "200",
		},
	],
	cztdsHeadData: [
		{
			title: "土地编号",
			prop: "tudbh",
			width: 160,
			align: "left",
			custom: true
		},
		{
			title: "宗地号",
			prop: "zondh",
			width: 160,
			align: "left"
		},
		{
			title: "土地名称",
			prop: "tudmc",
			width: 160,
			align: "left"
		},
		{
			title: "不动产权证号",
			prop: "budcqzh",
			width: 160,
			align: "left"
		},
		{
			title: "土地性质",
			prop: "tudxz",
			width: 160,
			align: "left",
			custom: true
		},
		{
			title: "土地用途",
			prop: "tudyt",
			width: 160,
			align: "left",
			custom: true
		},
		{
			title: "占用土地面积",
			prop: "zhanytdmj",
			width: "120",
			AmountFormat: true,
			align: "right"
		}, {
			title: "状态",
			prop: "caijFlag",
			width: "120",
			custom: true,
			align: "right"
		},
	],
	cztdsPagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	},
	cztdsFormlist: [
		{
			prop: "tudbh",
			label: "土地编号",
			isnotnull: true,
			type: "input",
		}, {
			prop: "zondh",
			label: "宗地号",
			type: "input",
		}, {
			prop: "tudmc",
			label: "土地名称	",
			type: "input",
		}, {
			prop: "nsrlx",
			label: "纳税人类型",
			isnotnull: true,
			type: "select",
			selectval: []
		}, {
			prop: "tudsyqNsrsbh",
			label: "土地使用权人纳税人识别号 (统一社会信用)",
			type: "input",
		}, {
			prop: "tudsyqMc",
			label: "土地使用权人名称",
			type: "input",
		}, {
			prop: "budcqzh",
			label: "不动产权证号",
			type: "input",
		}, {
			prop: "tudxz",
			label: "土地性质",
			type: "select",
			isnotnull: true,

		}, {
			prop: "tudyt",
			label: "土地用途",
			isnotnull: true,
			type: "select",
		}, {
			prop: "tudqdsj",
			label: "初始取得时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "tudqdfs",
			label: "土地取得方式",
			isnotnull: true,
			type: "select",
		}, {
			prop: "zhanytdmj",
			label: "占用土地面积",
			isnotnull: true,
			type: "input",
		}, {
			prop: "budcdydm",
			label: "不动产单元代码",
			type: "input",
		}, {
			prop: "shuiebz",
			label: "税额标准",
			isnotnull: true,

			type: "input",
		},{
			prop: "nsywYxqq",
			label: "纳税义务有效期起",
			type: "date",
			isdate: true,
			isnotnull: true,

			valueformat:'yyyy-MM-dd'
		},
		{
			prop: "tudzldzShi",
			label: "",
			type: "input",
			slot: true
		}, {
			prop: "tudzldzXiangz",
			label: "土地坐落地址(所处街乡)",
			isnotnull: true,
			type: "select",
			selectval: []
		}, {
			prop: "tudzldzXx",
			label: "土地坐落详细地址",
			isnotnull: true,
			type: "input",
		}, {
			prop: "tudsszgsws",
			label: "主管税务所(科，分局)",
			isnotnull: true,
			type: "input",
		}, {
			prop: "pikbz",
			label: "批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		},{
			prop: "dij",
			label: "地价",
			type: "input",
		}, {
			prop: "qudtdsyqje",
			label: "其中取得土地使用权支付金额",
			type: "input",
		}, {
			prop: "tudkfcb",
			label: "其中土地开发成本",
			type: "input",
		},  {
			prop: "jingbr",
			label: "经办人",
			type: "input",
		},{
			prop: "jingbrsfzhm",
			label: "经办人身份证件号码",
			type: "input",
		}, {
			prop: "shoulr",
			label: "受理人",
			type: "input",
		}, {
			prop: "shoulrq",
			label: "受理日期",
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}, {
			prop: "shoulswjg",
			label: "受理税务机关",
			type: "input",
		},{
			prop: "tuddj",
			label: "土地等级",
			isnotnull: true,

			type: "select",
		},{
			prop: "nsywYxqz",
			label: "纳税义务有效期止",
			type: "date",
			isdate: true,
			isnotnull: true,
			disabled:true,
			valueformat:'yyyy-MM-dd'
		},],
	cztdsFormdata: {
		nsywYxqz:'2099-12-31',
		tuddj:'',
		shuiebz:"",
		nsywYxqq:'',
		shoulswjg: '',
		jingbr: '',
		jingbrsfzhm: '',
		shoulr: '',
		shoulrq: '',
		pikbz: '',
		qudtdsyqje: '',
		tudkfcb: '',
		tudbh: '',
		zondh: '',
		tudmc: '',
		nsrlx: '',
		tudsyqNsrsbh: '',
		tudsyqMc: '',
		budcqzh: '',
		tudxz: '',
		tudyt: '',
		tudqdsj: '',
		tudqdfs: '',
		zhanytdmj: '',
		tudzldzShi: '',
		tudzldzXiangz: '',
		tudzldzXx: '',
		tudsszgsws: '',
		budcdydm: '',
		dij: '',
	},
	cjfcHeadData: [
		{
			title: "纳税人类型",
			prop: "nsrlxx",
			width: "90",
			custom: true
		}, {
			title: "纳税义务有效期起",
			prop: "nsywYxqq",
			width: "120",
		}, {
			title: "纳税义务有效期止",
			prop: "nsywYxqz",
			width: "120",
		},
		{
			title: "土地编号",
			prop: "fangwsztdbh",
			width: "80"
		},
		{
			title: "房屋所在土地编号",
			prop: "fangwsztdbh",
			width: "120"
		},
		{
			title: "房产名称",
			prop: "fangcmc",
			width: 160,
			align: "left"
		},
		{
			title: "不动产权证号",
			prop: "budcqzh",
			width: "130"
		},
		{
			title: "建筑面积",
			prop: "jianzmj",
			width: "80",
			AmountFormat: true,
			align: "right"
		}, {
			title: "状态",
			prop: "caijFlag",
			width: "120",
			custom: true,
			align: "right"
		}
	],
	cjfcPagination: {
		pageNum: 1,
		pageSize: 50,
		total: 0,
		paginationkey: 0
	},
	fcFormList1: [
		{
			prop: "fangcbh",
			label: "房产编号",
			isnotnull: true,
			type: "input",
		},
		{
			prop: "fangcmc",
			label: "房产名称",
			type: "input",
		},
		{
			prop: "fangcyt",
			label: "房屋用途",
			isnotnull: true,
			type: "select",
		},
		{
			prop: "fangcqdsj",
			label: "房产取得时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		},
		{
			prop: "jianzmj",
			label: "建筑面积",
			isnotnull: true,
			type: "input",
		},
		{
			prop: "nsrlx",
			label: "纳税人类型",
			isnotnull: true,
			type: "select",
		},
		{
			prop: "suoyqNsrsbh",
			label: "所有权人纳税人识别号 (统一社会信用代码)",
			type: "input",
		},
		{
			prop: "suoyqMc",
			label: "所有权名称",
			type: "input",
		},
		{
			prop: "cqzhlx",
			label: "产权证号类型",
			type: "select",
		},
		{
			prop: "budcdydm",
			label: "不动产单位代码",
			type: "input",
		},
		{
			prop: "budcqzh",
			label: "不动产权证号",
			type: "input",
		},
		{
			prop: "fangwsztdbh",
			label: "房屋所在土地编号",
			type: "input",
		}
	],
	fcFormList2: [
		{
			prop: "fangwzldzShi",
			label: "",
			slot: true,
			type: "select",
		},
		{
			prop: "fangwzldzXiangz",
			label: "房屋坐落地址(所处街乡)",
			type: "select",
			isnotnull: true,
			selectval: []
		},
		{
			prop: "fangwzldzXx",
			label: "房屋坐落详细地址",
			isnotnull: true,
			type: "input",
		},
		{
			prop: "fangczgsws",
			label: "房屋所属税务所(科，分局)",
			isnotnull: true,
			type: "input",
		}
	],
	fcFormList3: [
		{
			prop: "fangcyz",
			label: "房产原值",
			type: "input",
			isnotnull: true,
		},
		{
			prop: "chuzfcyz",
			label: "出租房产原值",
			type: "input",
			isnotnull: true,
		},
		{
			prop: "chuzfcmj",
			label: "出租面积",
			isnotnull: true,
			type: "input",
			slot: true,
		},
		{
			prop: "jisbl",
			label: "计税比例",
			isnotnull: true,
			type: "input",
		}
	],
	fcFormList4: [
		{
			prop: "czchuzfcmj",
			label: "出租面积",
			type: "input",
			disabled: true
		},
		{
			prop: "chengzNsrsbh",
			label: "承租方纳税人识别号",
			type: "input",
			disabled: true
		},
		{
			prop: "zulqq",
			label: "申报期起",
			type: "date",
			isdate: true,
			valueformat: 'yyyy-MM-dd',
			disabled: true
		},
		{
			prop: "chengzMc",
			label: "承租方名称",
			type: "input",
			disabled: true
		},
		{
			prop: "shenbzjsr",
			label: "申报租金收入",
			type: "input",
			disabled: true
		},
		{
			prop: "zulqz",
			label: "申报期止",
			type: "date",
			isdate: true,
			valueformat: 'yyyy-MM-dd',
			disabled: true
		}
	],
	fcFormList5: [
		{
			prop: "congjpkbz",
			label: "从价批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		},
		{
			prop: "dailrysfzlx",
			label: "代理人员身份证件类型",
			type: "select",
			selectval: comMapping.$cztds,
		},
		{
			prop: "dailrmc",
			label: "代理人名称",
			type: "input",
		},
		{
			prop: "shoulrq",
			label: "受理日期",
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		},
		{
			prop: "nsywYxqq",
			label: "纳税义务有效期起",
			type: "date",
			isdate: true,
			isnotnull: true,
			valueformat: "yyyy-MM-dd",
		},
		{
			prop: "congzpkbz",
			label: "从租批扣标志",
			type: "select",
			selectval: [{
				value: '0',
				label: '是',
			}, {
				value: '1',
				label: '否',
			}]
		},
		{
			prop: "dailrsfzhm",
			label: "代理人身份证件号码",
			type: "input",
		},
		{
			prop: "shoulr",
			label: "受理人",
			type: "input",
		},
		{
			prop: "shoulswjg",
			label: "受理税务机关",
			type: "input",
		},
		{
			prop: "nsywYxqz",
			label: "纳税义务有效期止",
			type: "date",
			isdate: true,
			isnotnull: true,
			valueformat: "yyyy-MM-dd",
		},
		{
			prop: "bgsj",
			label: "变更时间",
			isnotnull: true,
			type: "date",
			isdate: true,
			valueformat: "yyyy-MM-dd",
		}
	],
	cjfcFormdata: {
		jisbl: '',
		chuzfcyz: '',
		nsywYxqz: '',
		nsywYxqq: '',
		cqzhlx: '',
		bdcdwdm: '',
		fangcyz: '',
		congjpkbz: '',
		congzpkbz: '',
		dailrysfzlx: '201',
		dailrsfzhm: '',
		dailrmc: '',
		shoulr: '',
		shoulrq: '',
		shoulswjg: '',
		fangcbh: '',
		fangwsztdbh: '',
		fangcmc: '',
		budcqzh: '',
		nsrlx: '',
		fangcyt: '',
		suoyqNsrsbh: '',
		suoyqMc: '',
		fangwzldzXian: '',
		fangwzldzXiangz: '',
		fangwzldzXx: '',
		fangczgsws: '',
		fangcqdsj: '',
		jianzmj: '',
		bgsj: "",
		czchuzfcmj: "",
		chengzMc: "",
		chengzNsrsbh: "",
		shenbzjsr: "",
		zulqq: "",
		zulqz: "",
	},
}
